import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { ThemeProvider } from "./ThemeContext"; // Import ThemeProvider
const API_URL = 'https://whatsbotapi.zerwone.com';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ThemeProvider>
      <App />
    </ThemeProvider>
);
